import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'

sync(store, router);

Vue.config.productionTip = false;

Vue.component(
  'loader',
  require('./components/Loader.vue').default
);

Vue.component(
  'ConfirmationDialog',
  require('./components/ConfirmationDialog.vue').default
);

Vue.component(
  'ToastMessage',
  require('./components/ToastMessage.vue').default
);

Vue.component(
  'DataTable',
  require('./components/DataTable.vue').default
);

Vue.component(
  'EditDialog',
  require('./components/EditDialog.vue').default
);

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
